function formatCurrency(value) {
  return new Intl.NumberFormat("en-BD", {
    style: "currency",
    currency: "BDT",
    maximumFractionDigits: 0,
  }).format(value);
}

export function ProductPrice({ price, comparePrice, discount }) {
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2">
      <span className="text-sm font-semibold text-neutral-950 md:text-base">
        {formatCurrency(price)}
      </span>

      {comparePrice ? (
        <span className="text-sm text-neutral-400 line-through">
          {formatCurrency(comparePrice)}
        </span>
      ) : null}

      {discount ? (
        <span className="rounded-full bg-red-50 px-2 py-1 text-xs font-semibold text-red-600">
          -{discount}%
        </span>
      ) : null}
    </div>
  );
}